export default function item(array, index) {
    return array.at(index);
}
